<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="2" height="2" stroke="currentColor"/>
<rect x="1.5" y="12.5" width="2" height="2" stroke="currentColor"/>
<rect x="12.5" y="1.5" width="2" height="2" stroke="currentColor"/>
<rect x="12.5" y="12.5" width="2" height="2" stroke="currentColor"/>
<path d="M12 14H4V13H12V14ZM14 12H13V4H14V12ZM3 12H2V4H3V12ZM12 3H4V2H12V3Z" fill="currentColor"/>
</svg>
